import React from 'react';
import { Flex, Heading, Text, Spinner } from '@theme-ui/components';
import LinkSelector from '../../Links/LinkSelector';
import LazyLoad from 'react-lazyload';
import ImageSelector from '../../Images/ImageSelector';
import componentOptionsSelector from '../../../helpers/componentOptionsSelector';
import TextBodySelector from '../../General/TextBodySelector';

export default function SideBySideV2(props) {
  // === Destructing ==
  const {
    options,
    businessData,
    variantName,
    isMultiLocationSite,
    allGeneral,
    // city,
    // configData,
    // customPageName,
    // pageComponents,
    locationIndex,
    poweredImages,
    // locations,
    // pageObjectKey,
    // pageTitle,
    // gonationID,
  } = props;

  const storyId = options.storyId?.[locationIndex];

  const {
    titles,
    subtitles,
    texts,
    textType,
    ctaLinks,
    ctaNames,
    images,
    restrictCharacters,
    containerStyles,
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral);

  // const {
  //   ctaLinks,
  //   ctaNames,
  //   images,
  //   subtitles,
  //   texts,
  //   titles,
  //   containerStyles,
  //   restrictCharacters,
  // } = options

  const { city, desc } = businessData;

  // === Data Manipulation
  const styles = containerStyles ? JSON.parse(containerStyles) : {};

  // const textSupressor = (text) => {
  //   return restrictCharacters
  //     ? `${text.substring(0, restrictCharacters)}...`
  //     : text;
  // };

  return (
    <Flex
      variant={`${variantName}.container`}
      sx={styles}
      className='container'
    >
      <Flex variant={`${variantName}.content`} className='content'>
        {titles && (
          <Heading variant={`${variantName}.title`} className='title'>
            {titles}
          </Heading>
        )}
        {subtitles && (
          <Heading variant={`${variantName}.subtitle`} className='subtitle'>
            {subtitles}
          </Heading>
        )}
        <TextBodySelector
          variantName={`${variantName}`}
          texts={texts}
          textType={textType}
          restrictCharacters={restrictCharacters}
          desc={desc}
        />
        {/* {texts && (
          <Text as='p' variant={`${variantName}.text`} className='text'>
            {texts[locationIndex] !== 'about'
              ? textSupressor(texts[locationIndex])
              : textSupressor(desc)}
          </Text>
        )} */}
        {ctaLinks && ctaNames && (
          <LinkSelector
            className='linkContainer'
            variant={`${variantName}`}
            ctaName={ctaNames}
            ctaLink={ctaLinks}
            isMultiLocationSite={isMultiLocationSite}
            city={city}
          />
        )}
      </Flex>
      {images && (
        <Flex
          variant={`${variantName}.imageContainer`}
          className='imageContainer'
        >
          <LazyLoad
            placeholder={
              <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Spinner />
              </Flex>
            }
          >
            <ImageSelector
              variant={`${variantName}.image`}
              image={images[0]} // image from config
              poweredImages={poweredImages}
              className='image image1'
              locationIndex={locationIndex}
            />

            <ImageSelector
              variant={`${variantName}.image`}
              image={images[1]} // image from config
              poweredImages={poweredImages}
              className='image image3'
              locationIndex={locationIndex}
            />
          </LazyLoad>
        </Flex>
      )}
    </Flex>
  );
}
